import { render, staticRenderFns } from "./MyPlansWidget.vue?vue&type=template&id=0a87f3a2&scoped=true"
import script from "./MyPlansWidget.vue?vue&type=script&lang=js"
export * from "./MyPlansWidget.vue?vue&type=script&lang=js"
import style0 from "./MyPlansWidget.vue?vue&type=style&index=0&id=0a87f3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a87f3a2",
  null
  
)

export default component.exports